<template>
  <header class="w-full overflow-x-hidden pb-4 z-20">
    <blog-header :html-string="htmlString" :heading-text="headingText"/>
    <div class="mt-3 text-right text-secondary font-bold">
      Begeleider worden? <nuxt-link to="/registreren" class="link-secondary">Registreer</nuxt-link> nu!
    </div>
  </header>
</template>

<script>
import BlogHeader from '~/components/headers/BlogHeader';

export default {
  components: {BlogHeader},
  props: {
    htmlString: {
      type: String,
      default: '',
    },
    headingText: {
      type: String,
      default: '',
    },
  },
};
</script>
